import styled from 'styled-components';

export const $PageContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

export const $PageSubtitle = styled.p`
  margin: 0.5rem 0 0;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.newUI.variationColors?.dark2 || '#666'};
`;

export const $EmptyPublishedState = styled.div`
  margin-top: 2rem;
  padding: 2rem;
  text-align: center;
  border: 1px dashed ${({ theme }) => theme.newUI.variationColors?.light2 || '#ccc'};
  border-radius: 8px;
  color: ${({ theme }) => theme.newUI.variationColors?.dark2 || '#666'};
`;

export const $AccordionHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 0.5rem;

  button {
    flex-shrink: 0;
  }
`;

export const $ModalDescription = styled.p`
  margin: 0.75rem 0 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.newUI.variationColors?.dark2 || '#666'};
`;

export const $AccordionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const $RulesTableWrapper = styled.div`
  margin-top: 0.5rem;
  border: 1px solid ${({ theme }) => theme.newUI.variationColors?.light3 || '#e0e0e0'};
  border-radius: 4px;
  overflow: hidden;
`;

export const $RulesTableHeader = styled.div<{ $columnCount: number }>`
  display: grid;
  grid-template-columns: 140px repeat(${({ $columnCount }) => $columnCount}, minmax(120px, 1fr));
  gap: 0;
  background-color: ${({ theme }) => theme.newUI.variationColors?.light5 || '#f5f5f5'};
  border-bottom: 1px solid ${({ theme }) => theme.newUI.variationColors?.light3 || '#e0e0e0'};
  font-size: 0.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.newUI.variationColors?.dark2 || '#666'};
`;

export const $RulesTableRow = styled.div<{ $columnCount: number }>`
  display: grid;
  grid-template-columns: 140px repeat(${({ $columnCount }) => $columnCount}, minmax(120px, 1fr));
  gap: 0;
  border-bottom: 1px solid ${({ theme }) => theme.newUI.variationColors?.light4 || '#eee'};
  font-size: 0.875rem;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.newUI.variationColors?.light5 || '#fafafa'};
  }
`;

export const $RulesTableCell = styled.div`
  padding: 0.75rem 1rem;
  display: flex;
  align-items: flex-start;
  min-width: 0;
  word-break: break-word;
`;

export const $PreviousValue = styled.span`
  display: block;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.newUI.variationColors?.dark2 || '#888'};
  text-decoration: line-through;
  margin-bottom: 0.25rem;
`;

export const $CurrentValue = styled.span`
  display: block;
  color: ${({ theme }) => theme.newUI.defaultColors?.text || '#333'};
`;

export const $FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 2rem;
  padding-top: 1rem;
`;

export const $ModalFieldLabel = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.newUI.defaultColors?.text || '#333'};
`;

export const $ModalTextarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 0.75rem;
  border: 1px solid ${({ theme }) => theme.newUI.variationColors?.light2 || '#ccc'};
  border-radius: 4px;
  font-family: inherit;
  font-size: 0.875rem;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors?.primary || '#2196f3'};
  }
`;

export const $ModalError = styled.p`
  color: #d32f2f;
  font-size: 0.8rem;
  margin-top: 0.35rem;
`;
